export const adjustCredit = {
	heading: {
		sv: "Fördela krediten",
	},
	subHeading: {
		sv: "Här kan du fördela din kredit på de produkter som ingår i ditt paket.",
	},
	title: {
		sv: "Fördela din kredit",
	},
	creditPoolDescription: {
		sv: "Kreditpott kvar att använda",
	},
	creditExceededWarning: {
		sv: "Du har överskridit din möjliga kreditpott. Fördela om summan så att den inte är på minus.",
	},
	FORETAGARNA_CREDITCARD: {
		title: {
			sv: "Företagarna Kreditkort",
		},
		description: {
			sv: `Företagarna kreditkort är nu äntligen här.`,
		},
	},
	CREDITCARD: {
		title: {
			sv: "Svea Kreditkort",
		},
		description: {
			sv: `Med Svea Kreditkort ingår Mastercard LoungeKey och reseförsäkring. Hur stort
        kreditbelopp du vill ha på kortet väljer du själv genom att fördela företagets
        kreditpott.`,
		},
	},
	CHECKKREDIT: {
		title: {
			sv: "Kontokredit",
		},
		description: {
			sv: `Vår kontokredit är kopplad till ditt företagskonto och ger dig tillgång till
        extra kapital när du behöver det. Kreditbeloppet sätter du själv genom att fördela din
        kreditpott. Kontokredit på upp till 100 000 kronor ingår i Växa-paketet`,
		},
	},
	noAddonsModal: {
		title: {
			sv: "Dina kreditprodukter är borttagna",
		},
		description: {
			sv: "Du har inga kreditprodukter kvar i din beställning.",
		},
	},
	amount: {
		sv: "Belopp",
	},
	isAddon: {
		sv: "Extra produkt (ingår inte i valt paket)",
	},
	notAddon: {
		sv: "Ingår i valt paket",
	},
	addons: {
		sv: "Tilläggsprodukter",
	},
	creditExceeded: {
		sv: "Krediten har överskridits med {0}. Minska eller omfördela för att gå vidare.",
	},
	costSummary: {
		totalSum: {
			sv: "Total summa",
		},
		subCost: {
			sv: "{0} kr/mån",
		},
	},
};
